import { Notification, NotificationState } from './index';
// import { PropType } from "../avroom/mutations";

const mutations = {
  setMessage(state: NotificationState, message: Omit<Notification, 'closed'>) {
    if (!state.message) {
      state.message = [{ ...message, closed: false }];
    } else {
      state.message = [{ closed: false, ...message }].concat(state.message);
    }
  },
  unsetMessage(state: NotificationState, m: number | Notification) {
    if (typeof m === 'number' && state.message) {
      const message = state.message[m];
      if (message) {
        message.closed = true;
      }
    } else {
      const message = state.message?.filter(msg => msg === m) || null;
      if (message && message[0]) {
        message[0].closed = true;
      }
    }
  },
  loadAllMessages(state: NotificationState, posts: Notification[]) {
    state.message = posts;
  }
};

export type NotificationMutations = typeof mutations;
export default mutations;
